<div id="head"></div>
<h1 class="sr-only">Contact Us</h1>

<div class="pl-page">

  <!-- The Apps & Plugins hero band (owner 2026-10-12): the title and one line -->
  <header class="pl-hero">
    <div class="pl-hero-inner">
      <p class="tools-title" aria-hidden="true">Contact Us</p>
      <p class="tools-subtitle">Tell us about your custom needs and our team will get back to you</p>
    </div>
  </header>

  <!-- The form in the nav's Contact Us popover card (owner 2026-10-12): the same form, the same frosted card -->
  <div class="contact-body">
    <div class="contact-card">
      <app-contact-form class="cf-large" source="Contact Page" [head]="false"></app-contact-form>
    </div>
  </div>
</div>
